import { defineComponent as _defineComponent } from 'vue'
import {
  ProtestCategory,
  useProtestEventsStore,
} from "@/stores/protest-events";
import { computed, withDefaults } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LocalAnalysisDataAlert',
  props: {
    cities: { default: () => [] },
    forms: { default: () => [] },
    claims: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { cities: ProtestCategory[], forms: ProtestCategory[], claims: ProtestCategory[] }



const protestEventsStore = useProtestEventsStore();

const totalEvents = computed<string>(() => {
  return protestEventsStore
    .totalEvents(props.cities, props.forms, props.claims, false)
    .toLocaleString("de");
});

const totalEventsWithMissingParticipants = computed<string>(() => {
  return protestEventsStore
    .totalEventsWithMissingParticipants(
      props.cities,
      props.forms,
      props.claims,
      false
    )
    .toLocaleString("de");
});

return { __sfc: true,props, protestEventsStore, totalEvents, totalEventsWithMissingParticipants }
}

})